import { combineReducers } from 'redux';
import { storeKey as authKey, reducer as authReducer } from './authDuck';
import { storeKey as configurationKey, reducer as configurationReducer } from './configurationDuck';
import { storeKey as navKey, reducer as navReducer } from './navDuck';
import { storeKey as organizationKey, reducer as organizationsReducer } from './organizationDuck';
import { storeKey as userKey, reducer as userReducer } from './userDuck';

export default combineReducers({
  [authKey]: authReducer,
  [organizationKey]: organizationsReducer,
  [userKey]: userReducer,
  [configurationKey]: configurationReducer,
  [navKey]: navReducer,
});
